import { useState } from "react";

import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import { PermissionsKeys } from "components/permissions/permission-keys";
import { PermissionTooltipButton } from "components/permissions/permissions";
import { Subscription as SubscriptionData } from "data/models";

import { CancelSubscriptionDialog } from "./cancel-subscription-dialog";

interface CancelSubscriptionCardProps {
  subscription: SubscriptionData;
  hasScheduledUpgradeOrDowngrade: boolean;
  hasScheduledCancellation: boolean;
}

export const CancelSubscriptionCard = ({
  subscription,
  hasScheduledUpgradeOrDowngrade,
  hasScheduledCancellation,
}: CancelSubscriptionCardProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Need to take a break?</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm">
          Cancel your subscription at any time, you'll lose access to hub
          features at the end of your current subscription term.
        </p>
      </CardContent>
      <CardFooter className="flex justify-end">
        <PermissionTooltipButton
          permissionKeys={[PermissionsKeys.subscriptionDelete]}
          variant="destructive"
          additionalDisabled={
            hasScheduledUpgradeOrDowngrade || hasScheduledCancellation
          }
          onClick={() => setOpen(true)}
        >
          Cancel subscription
        </PermissionTooltipButton>
      </CardFooter>

      <CancelSubscriptionDialog
        open={open}
        onOpenChange={setOpen}
        subscription={subscription}
      />
    </Card>
  );
};
